import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-financial-tax-page',
  templateUrl: './tax-page.component.html',
  styleUrls: ['./tax-page.component.scss']
})
export class FinancialTaxPageComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {
    this.router.navigate(['benefits/allforms/taxform'], {
      queryParamsHandling: 'preserve'
    });
  }
}
